import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import Modal from 'components/v2/modal';
import CommentList from 'components/modules/comments/CommentList';

export default forwardRef(
  ({ value, stopEditing, data, onCommentAdd: onCommentAddProp }, ref) => {
    const [comments, setComments] = useState(value || []);
    const isMounted = React.useRef(true);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return comments;
        },
      };
    });

    useEffect(() => {
      return () => {
        isMounted.current = false;
      };
    }, []);

    const onCommentAdd = async (message) => {
      const comment = await onCommentAddProp(message, data.shipment_oid);

      if (isMounted.current) {
        setComments([...comments, comment]);
      }
    };

    return (
      <Modal show onHide={stopEditing} title="Discussion" enforceFocus={false}>
        <CommentList
          paginate
          itemsPerPage={10}
          comments={comments}
          onCommentAdd={onCommentAdd}
        />
      </Modal>
    );
  },
);
